/**
 * @fileoverview Connect browser conflict-check availability to backend feature configuration. Shared request state determines whether hosting workspaces expose the panel; backend admission and subject permissions remain authoritative. Feature visibility is separate from conducting or closing a conflict review.
 */

import { useEffect, useState } from 'react';
import api from '../../api';

let cachedEnabled = null;
let pending = null;



export function fetchConflictChecksEnabled() {
  if (cachedEnabled !== null) return Promise.resolve(cachedEnabled);
  if (!pending) {
    // Promise.resolve guards callers (and test mocks) whose api.get returns nothing.
    pending = Promise.resolve()
      .then(() => api.get('/conflict-checks/config'))
      .then((response) => {
        cachedEnabled = Boolean(response?.data?.enabled);
        return cachedEnabled;
      })
      .catch(() => {
        pending = null;
        return false;
      });
  }
  return pending;
}

 
export function resetConflictChecksEnabledCache() {
  cachedEnabled = null;
  pending = null;
}



export default function useConflictChecksEnabled() {
  const [enabled, setEnabled] = useState(cachedEnabled === true);
  useEffect(() => {
    let active = true;
    fetchConflictChecksEnabled().then((value) => {
      if (active) setEnabled(value);
    });
    return () => {
      active = false;
    };
  }, []);
  return enabled;
}
